// extracted by mini-css-extract-plugin
module.exports = {"list":"facet-FacetGroups__list--Esyw2","item":"facet-FacetGroups__item--1x1Ok"};